// extracted by mini-css-extract-plugin
module.exports = {"link":"brands_link__anT1i","label":"brands_label__tgyQM","image":"brands_image__xTk2L","spacer":"brands_spacer__6wQKx","phAnimation":"brands_phAnimation__jaRr5"};